import React from "react";
import { useQuery } from "@tanstack/react-query";
import { transactionService } from "../../services/transactions";
import LoadingSpinner from "../Common/LoadingSpinner";

export default function AgingReport() {
  const { data, isLoading } = useQuery({
    queryKey: ["aging-report"],
    queryFn: () => transactionService.getAgingReport()
  });

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h3 className="text-lg font-semibold mb-4">Aging Report (Debtors)</h3>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2">Customer</th>
              <th className="px-4 py-2">1-30 Days</th>
              <th className="px-4 py-2">31-60 Days</th>
              <th className="px-4 py-2">61-90 Days</th>
              <th className="px-4 py-2">90+ Days</th>
              <th className="px-4 py-2">Total</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.map(c => (
              <tr key={c.id}>
                <td className="px-4 py-2">{c.name}</td>
                <td className="px-4 py-2">KES {c.days_1_30?.toLocaleString()}</td>
                <td className="px-4 py-2">KES {c.days_31_60?.toLocaleString()}</td>
                <td className="px-4 py-2">KES {c.days_61_90?.toLocaleString()}</td>
                <td className="px-4 py-2">KES {c.over_90_days?.toLocaleString()}</td>
                <td className="px-4 py-2 font-bold">KES {c.current_balance?.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}